export const useUpdateFieldContext = ({
  componentName,
  context,
  fieldName,
  setMetadataForFieldName,
  translations,
}) => {
  setMetadataForFieldName(fieldName, {
    componentName,
    context: {
      ...context,
      parent: '@@',
    },
    translations,
  });
};
